var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStreamSchedule = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#908CA0",
    fillRule: "evenodd",
    d: "M.205 11c0 5.953 4.842 10.795 10.795 10.795S21.794 16.953 21.794 11 16.953.206 11 .206a1.278 1.278 0 0 0-1.278 1.277v2.96a1.278 1.278 0 1 0 2.555 0V2.859c3.94.616 6.962 4.033 6.962 8.141 0 4.544-3.696 8.24-8.24 8.24-4.542 0-8.239-3.696-8.239-8.239a8.303 8.303 0 0 1 2.414-5.828 1.277 1.277 0 0 0-1.808-1.806A10.865 10.865 0 0 0 .205 11Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#908CA0",
    d: "m12.483 9.507-.024-.024-4.041-2.87a1.277 1.277 0 0 0-1.806 1.805l2.87 4.04.024.025a2.105 2.105 0 1 0 2.977-2.976Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStreamSchedule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stream-schedule.1fb864819750d6c57730319a51f0e19f.svg";